import { render, staticRenderFns } from "./StoragesManager.vue?vue&type=template&id=674ca7fa&"
import script from "./StoragesManager.vue?vue&type=script&lang=ts&"
export * from "./StoragesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports